import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "font-bold" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "Address 1: ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "Address 2: ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "City: ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "Province - Zip: ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Country Code: ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, "Phone: ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Email: ", -1)
const _hoisted_9 = { class: "text-xs" }
const _hoisted_10 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_11 = {
  key: 1,
  class: "text-xs"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 2,
  class: "text-xs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.props.scope.row.fullName) + " ", 1),
      _createVNode(_component_el_popover, {
        placement: "top-start",
        width: "auto",
        trigger: "hover"
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_InfoFilled)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, { class: "text-x font-bold" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.props.scope.row.fullName), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { class: "mt-3" }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createTextVNode(" " + _toDisplayString(_ctx.props.scope.row.address1), 1)
                ]),
                _: 1
              }),
              (_ctx.props.state.order.address2)
                ? (_openBlock(), _createBlock(_component_el_row, {
                    key: 0,
                    class: "mt-2"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _createTextVNode(" " + _toDisplayString(_ctx.props.scope.row.address2), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_row, { class: "mt-2" }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createTextVNode(" " + _toDisplayString(_ctx.props.scope.row.city), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { class: "mt-2" }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString(_ctx.props.scope.row.province) + " - " + _toDisplayString(_ctx.props.scope.row.zipCode), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { class: "mt-2" }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(_ctx.props.scope.row.countryCode), 1)
                ]),
                _: 1
              }),
              (_ctx.props.scope.row.phone)
                ? (_openBlock(), _createBlock(_component_el_row, {
                    key: 1,
                    class: "mt-2"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _hoisted_7,
                        _createTextVNode(" " + _toDisplayString(_ctx.props.scope.row.phone), 1)
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.props.scope.row.email)
                ? (_openBlock(), _createBlock(_component_el_row, {
                    key: 2,
                    class: "mt-2"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _createTextVNode(" " + _toDisplayString(_ctx.props.scope.row.email), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("p", _hoisted_9, _toDisplayString(`(${_ctx.props.scope.row.countryCode} - ${_ctx.props.scope.row.province} - ${_ctx.props.scope.row.zipCode})`), 1),
    (_ctx.props.scope.row.address1)
      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(`${_ctx.props.scope.row.address1}`), 1))
      : _createCommentVNode("", true),
    (_ctx.props.scope.row.email)
      ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
          (_ctx.props.scope.row.phone)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(`${_ctx.props.scope.row.phone} -`), 1))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(`${_ctx.props.scope.row.email}`), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.props.scope.row.transactionId)
      ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(`${_ctx.props.scope.row.transactionId}`), 1))
      : _createCommentVNode("", true)
  ], 64))
}